<form *ngIf="ready"
      novalidate
      #accountCreateForm="ngForm"
      id="accountCreateForm"
      name="accountCreateForm"
      class="form">

    <app-success-notification [messages]="successMessages"></app-success-notification>
    <app-error-notification [errors]="errorMessages"></app-error-notification>

    <div class="row mt-0125"
         *ngIf="successMessages.length">
        <h4 class="h4">Additional User</h4>
    </div>

    <div class="row mt-0125">

        <div class="col col--050">
            <mat-form-field [hideRequiredMarker]="true"
                            class="col__">
                <mat-label>First Name</mat-label>
                <input matInput
                       required
                       type="text"
                       name="firstName"
                       id="firstName"
                       data-test-id="firstName"
                       [(ngModel)]="createInvitiationFormModel.firstName">
            </mat-form-field>
        </div>

        <div class="col col--050">
            <mat-form-field [hideRequiredMarker]="true"
                            class="col__">
                <mat-label>Last Name</mat-label>
                <input matInput
                       required
                       type="text"
                       name="lastName"
                       id="lastName"
                       data-test-id="lastName"
                       [(ngModel)]="createInvitiationFormModel.lastName">
            </mat-form-field>
        </div>

    </div>

    <div class="row">
        <div class="col col--050">
            <mat-form-field [hideRequiredMarker]="true"
                            class="col__">
                <mat-label>Email Address</mat-label>
                <input matInput
                       type="email"
                       id="email"
                       name="email"
                       data-test-id="email"
                       [(ngModel)]="createInvitiationFormModel.email"
                       required>
            </mat-form-field>
        </div>
        <div class="col col--050">
            <mat-form-field class="col__">
                <mat-label>Account Type</mat-label>
                <mat-select placeholder="Account Type"
                            name="role"
                            data-test-id="role"
                            [(ngModel)]="createInvitiationFormModel.role">
                    <mat-option *ngFor="let role of roleOptions"
                                [value]="role.value">
                        {{ role.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div *ngIf="createInvitiationFormModel.role && createInvitiationFormModel.role != 'Administrator'">

        <h3 class="h-01 mt-0050 pb-0050">Access &amp; Assignments</h3>
        <div *ngFor="let campaignAssignment of createInvitiationFormModel.campaigns; let i = index;">

            <div class="box pb-0100 border-1">
                <div class="flex flexJustify--between flexAlign--baseline">
                    <h3 class="h-02 col__ mt-0050 pb-0050">Campaign Access</h3>
                    <app-campaign-select2 class="col__"
                                          [ngClass]="{gutter: i > 0}"
                                          [selectedItem]="campaignAssignment.campaign"
                                          (selectedItemChange)="onCampaignSelected($event, campaignAssignment)">
                    </app-campaign-select2>
                    <div>
                        <i *ngIf="i > 0"
                           class="fal fa-times guide__icon mr-0025"
                           data-test-id="removeCampaignBtn"
                           (click)="onClickRemoveCampaign(i)">
                        </i>
                    </div>
                </div>

                <div class="d-flex flexWrap-wrap flexJustify-between flexAlign-baseline"
                     *ngIf="campaignAssignment.campaign?.id">
                    <app-account-turf-input name="assignments{{i}}"
                                            class="col__"
                                            [campaignId]="campaignAssignment.campaign?.id"
                                            [(ngModel)]="campaignAssignment.assignment"
                                            [role]="createInvitiationFormModel.role"
                                            [attr.data-test-id]="'turfAssignments'+i">
                    </app-account-turf-input>
                </div>
            </div>

            <div class="d-flex flexWrap-wrap flexJustify-between flexAlign-baseline pb-0075">
                <a class="link link--small link--noline mt-0100 ml-auto pb-0125"
                   data-test-id="addAnotherCampaign"
                   *ngIf="campaignAssignment.campaign?.id && createInvitiationFormModel.campaigns.length == i + 1"
                   (click)="onClickAddCampaign()">
                    <i class="far fa-plus"></i>
                    Add Another Campaign
                </a>
            </div>

        </div>
    </div>

    <div class="d-flex flexWrap-wrap flexJustify-end ">
        <button *ngIf="!hideAddAnother"
                class="btn btn--white mt-0050 ml-0050"
                data-test-id="addAnotherBtn"
                [disabled]="isSubmitting"
                (click)="sendInvite(accountCreateForm)"
                type="button">Invite &amp; Add Another User</button>
        <button class="btn mt-0050 ml-0050"
                data-test-id="submitBtn"
                [disabled]="isSubmitting"
                (click)="sendInvite(accountCreateForm, false)"
                type="button">Invite User</button>

    </div>

</form>
